// @flow
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import drag from "../../../images/common/drag.svg";
import I18n from "../../../i18n/I18n";
import styles from "./UploadView.scss";
import Button from "../../common/button/Button";

type Props = {
    data: Array
}

class UploadView extends Component<Props> {
    constructor(props: Object) {
      super(props);
      this.state = {
        accepted: [],
        rejected: [],
        newFile: null,
        success: props.success,
        error: props.error
      };
    }

    onDrop = (accepted: Array<Object>, rejected: Array<Object>) => {
      this.setState({ accepted, rejected, success: "", error: "" });
    };

    render() {
        const vatNumber = this.props.vatNumber;
        return (
            <div className={styles.ctr}>
                <div className={styles.uploadHeading}>
                    {I18n.getText("settings.upload-heading-vat-info", {}, "Vat Info")}
                </div>
                <div className={styles.box}>
                    <p className={styles.header}>
                        {I18n.getText("settings.vat-vat-number", {}, "Vat Number")}
                    </p>
                    <p className={styles.bold}>
                        { vatNumber }
                    </p>
                </div>
                {/* <div className={styles.dropZone}>
                    <Dropzone
                      className={styles.dropArea}
                      multiple={false}
                      onDrop={this.onDrop}
                    >
                        <div className={styles.wrapper}>
                            <div className={styles.imageCtr}>
                              <img src={drag} alt="upload"/>
                            </div>
                            <div className={styles.dragText}>
                              {I18n.getText(
                                "settings.drag-text-1",
                                {},
                                "Drag & Drop or "
                              )}
                              &nbsp;
                              <span className={styles.browse}>
                                {I18n.getText("products.browse", {}, "Browse")}
                              </span>
                              &nbsp;
                              {I18n.getText(
                                "settings.drag-text-2",
                                {},
                                "from a computer "
                              )}
                              <div className={styles.sizeSummary}>
                                  {I18n.getText(
                                    "settings.drag-text-summary-size",
                                    {},
                                    "Individual file size limit is 10mb "
                                  )}
                              </div>
                            </div>
                        </div>
                    </Dropzone>
                    {this.state.accepted.map(f => (
                      <div
                        className={`${styles.accepted} ${
                          this.state.success ? styles.success : ""
                        }`}
                      >
                          <div>
                            {f.name} - {f.size} bytes
                          </div>
                      </div>
                    ))}
                    {this.state.success ? (
                      <div
                        className={`${styles.accepted} ${
                          this.state.success ? styles.success : ""
                        }`}
                      >
                        <div>
                          {I18n.getText("settings.imported", {}, "Imported Successfully")}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.error ? (
                      <div className={styles.rejected}>{this.state.error}</div>
                    ) : (
                      ""
                    )}
                    {this.state.rejected.map(f => (
                      <div className={styles.rejected}>
                        {f.name} - {f.size} bytes
                      </div>
                    ))}
                </div> */}
                <div className={styles.btnWrapper}>
                    <a
                      href="https://verify.noon.com/en-ae/partner-vat-registration"
                      target="_blank"
                    >
                    <Button
                      className={styles.btn}
                    //   onClick={() => this.onSubmit()}
                    >
                        {I18n.getText("settings.upload-submit")}
                    </Button>
                </a>
                </div>
            </div>
        );
    }
}

export default UploadView;



// WEBPACK FOOTER //
// ./src/components/settings/uploadView/UploadView.js